import { render, staticRenderFns } from "./AppLauncherWarningContainer.vue?vue&type=template&id=65c6820a"
import script from "./AppLauncherWarningContainer.vue?vue&type=script&lang=ts"
export * from "./AppLauncherWarningContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.31_css-loader@7.1.4_webpack@5.105.4__ejs@3.1.10_hand_ylukk2m4i5f72bin4t3vwj3wvq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports